import React from 'react';
import { useMachine } from '@xstate/react';
import _noop from 'lodash/noop';

import { ManageGapAnalysisBody } from '.';
import { gapAnalysisMachine } from '../../../../hooks/useGapAnalysisTools';

interface StepStoryProps {
    context: GapAnalysisContext;
}

/**
 * A wrapper around <ManageGapAnalysisBody> that will be useful when creating Storybook files for
 * individual Gap Analysis step components.
 * @param props - {@link StepStoryProps}
 * @returns JSX
 */
export const StepStory = ({ context }: StepStoryProps): JSX.Element => {
    const [state, send] = useMachine<GapAnalysisContext, GapAnalysisEvent>(
        gapAnalysisMachine,
        {
            context,
        },
    );

    return (
        <div className="h-screen w-screen bg-tertiary-200 flex items-center justify-center">
            <ManageGapAnalysisBody
                context={state.context}
                remove={_noop}
                send={send}
            />
        </div>
    );
};
